import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom";
import {theme} from "./shared/theme/theme";
import {index} from "./store";
import {Provider} from "react-redux";
import {ToastContainer} from "react-toastify";
import {CloseButton} from "./shared/components/toast/toast-close-button/ToastCloseButton";
import '@fontsource/montserrat/400.css';
import '@fontsource/montserrat/500.css';
import '@fontsource/montserrat/600.css';
import '@fontsource/montserrat/700.css';
import './assets/styles/Toastify.css';
import KeycloakService from "./config/keycloak";
import {TolgeeProvider} from "@tolgee/react";
import {tolgee} from "./config/tolgee";
import {CssBaseline, ThemeProvider} from "@mui/material";

const root = ReactDOM.createRoot(document.getElementById('root'));
const renderApp = () => root.render(
    <React.Fragment>
        <Provider store={index}>
            <BrowserRouter>
                <TolgeeProvider tolgee={tolgee} >
                    <ThemeProvider theme={theme}>
                        <CssBaseline/>
                        <ToastContainer autoClose={4000}
                                        hideProgressBar
                                        closeButton={CloseButton}/>
                        <App/>
                    </ThemeProvider>
                </TolgeeProvider>
            </BrowserRouter>
        </Provider>
    </React.Fragment>,
    // document.getElementById('root')
);

// renderApp();
KeycloakService.initKeycloak(renderApp);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
